import {Component, inject} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {MatListOption, MatSelectionList} from "@angular/material/list";
import {CommonModule} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import { BaseModalComponent } from '../../base-modal/base-modal.component';
import {BloggerSearchDuplicatesProps, DialogData} from "../types/blogger-deduplication-modal.types";
import {RecordData, RecordsDataRequestQueryParams} from "../../../../types/records-table.types";
import {
  ConfirmDeduplicationModalComponent
} from "../confirm-deduplication-modal/confirm-deduplication-modal.component";
import {CloseModalReason} from "../../../../types/modal.types";
import {bloggerModalResourceType} from "../configs/blogger-modal-config";
import {BloggerModalService} from "../services/blogger-modal.service";
import {bloggerDeduplicationModalName} from "../configs/blogger-deduplication-modal-config";
import {LoaderComponent} from "../../../../../shared/components/loader/loader.component";
import {BloggerInfoComponent} from "../components/blogger-info/blogger-info.component";

@Component({
  selector: 'app-blogger-deduplication-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    FormsModule,
    MatButton,
    MatListOption,
    MatSelectionList,
    CommonModule,
    MatFormField,
    MatInput,
    MatLabel,
    LoaderComponent,
    BloggerInfoComponent
  ],
  templateUrl: './blogger-deduplication-modal.component.html',
  styleUrls: [
      './blogger-deduplication-modal.component.scss',
      '../../base-modal/base-modal.component.scss'
  ]
})
export class BloggerDeduplicationModalComponent extends BaseModalComponent {
  public dialogData = inject<DialogData>(MAT_DIALOG_DATA);
  private bloggerModalService: BloggerModalService = inject(BloggerModalService);
  private dialog: MatDialog = inject(MatDialog);

  public recordsDataRequestQueryParams: RecordsDataRequestQueryParams = this.prepareDefaultQueryParams();
  public bloggers: Array<RecordData> = [];
  public hasBloggers: boolean = false;
  public selectedBloggers: Array<RecordData> = [];
  public searchBloggerNameOrUrl: string = '';

  public override async ngOnInit():Promise<void> {
    super.ngOnInit();
    this.modalStatesService.openModal(bloggerDeduplicationModalName);
    this.searchBloggerNameOrUrl = this.dialogData.currentBlogger['url']
      ? this.dialogData.currentBlogger['url'] as string
      : this.dialogData.currentBlogger['username'] as string;
    await this.loadBloggers();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(bloggerDeduplicationModalName);
  }

  public async onSelectBlogger(): Promise<void> {
    if (!this.selectedBloggers) { return; }

    this.dialog.open(ConfirmDeduplicationModalComponent, {
      data: {
        originBlogger: this.dialogData.currentBlogger,
        duplicateBlogger: this.selectedBloggers[0],
        tableColumnParams: this.dialogData.tableColumnParams!
      },
      width: '500px'
    }).afterClosed().subscribe((result: CloseModalReason) => {
      if (result === 'success') {
        this.closeDialog('cancel');
      }
    });
  }

  public async loadBloggers() {
    const bloggerSearchDuplicatesProps = this.setBloggerSearchDuplicatesProps();

    this.loadingService.setIsLoadingState(true);
    this.bloggers = await this.bloggerModalService.bloggerSearchDuplicates(bloggerSearchDuplicatesProps).catch(() => []);
    this.hasBloggers = !!this.bloggers.length;
    this.loadingService.setIsLoadingState(false);
  }

  public handleOpenBloggerModal(bloggerData: RecordData): void {
    this.modalsService.getStatusFromBloggerCardModal({
      columnParamKey: 'blogger',
      columnParam: this.dialogData.tableColumnParams!,
      recordData: bloggerData,
      path: bloggerModalResourceType.path
    });
  }

  private setBloggerSearchDuplicatesProps(): BloggerSearchDuplicatesProps {
    return {
      path: bloggerModalResourceType.path,
      originalId: Number(this.dialogData.currentBlogger.id),
      search: this.searchBloggerNameOrUrl
    }
  }
}
